const initAdvisoryLinksSkeleton = () => {
    const advisoryLinksData = document.querySelector('.advisory-links-data')
    let count = Number(advisoryLinksData.dataset.linksheader) + Number(advisoryLinksData.dataset.linkslength);
    const skeleton = document.querySelector('.js-advisory-links-skeleton')
    const width = window.innerWidth
    if (width < 576 && count > 3) {
        count = 3
    }
    Array(count).fill(0).forEach((elem, idx, array) => {
        const div = document.createElement('div');
        if (idx === array.length - 1) {
            div.classList.add('skeleton-loader', 'mb-4');
        } else {
            div.classList.add('skeleton-loader', 'mb-3');
        }
        div.style.height = '45px'
        skeleton.appendChild(div)
    })
}
initAdvisoryLinksSkeleton()
